import Vue from 'vue'
import Vuex from 'vuex'
import Router from 'vue-router'
import VueResource from 'vue-resource'
import PortalVue from 'portal-vue'
import VueLazyLoad from 'vue-lazyload'
import VueTouch from 'vue-touch'
import guards from './guards'

// TO DO: uncomment dashboard when dashboard page built
// import Dashboard from '@/pages/dashboard.vue'
import Clients from '@/pages/client/clients.vue'
import ClientOverview from '@/pages/client/client-overview.vue'
import ClientsEdit from '@/pages/client/clients-edit.vue'
import ClientsAdd from '@/pages/client/clients-add.vue'
import ClientDashboard from '@/pages/client/client-dashboard.vue'
import ClientsInvoices from '@/pages/client/client-invoices.vue'
import ClientsCampaigns from '@/pages/client/campaigns/client-campaigns.vue'
import Campaigns from '@/pages/campaigns/campaigns.vue'
import CampaignCreatives from '@/pages/campaigns/campaign-creatives.vue'
import CreativeUnits from '@/pages/creatives/creative-units'
import SingleCreativeUnits from '@/pages/creatives/single-creative-unit'
import Projects from '@/pages/projects.vue'
import Templates from '@/pages/templates.vue'
import GIFPreview from '@/pages/dev/gif-preview.vue'
import JPGPreview from '@/pages/dev/jpg-preview.vue'
import PNGPreview from '@/pages/dev/png-preview.vue'
import HTMLPreview from '@/pages/dev/html-preview.vue'
import NOPreview from '@/pages/dev/no-preview.vue'
import Profile from '@/pages/profile.vue'
import Users from '@/pages/user/users.vue'
import UsersAdd from '@/pages/user/users-add.vue'
import UsersEdit from '@/pages/user/users-edit.vue'
import EncodingProfiles from '@/pages/encoding-profile/encoding-profiles.vue'
import Monitor from '@/pages/monitor/index.vue'
import Assets from '@/pages/assets.vue'
import Links from '@/pages/links.vue'
import Tags from '@/pages/tags/overview.vue'
import TagsDetail from '@/pages/tags/detail.vue'
import TagsCreative from '@/pages/tags/creative.vue'
import DownloadFile from '@/pages/downloads/file.vue'
import PreviewStaging from '@/pages/preview-staging.vue'
import Admin from '@/pages/admin.vue'
import RenderManager from '@/pages/render-manager.vue'
import Help from '@/pages/help.vue'
import Login from '@/pages/login.vue'
import Invoices from '@/pages/invoice/invoices.vue'
import InvoiceBreakdown from '@/pages/invoice/invoice-breakdown.vue'
import PageNotFound from '@/pages/404.vue'
import ReviewLinksType from '@/pages/review-links-type.vue'
import ForgotPassword from '@/pages/forgot-password.vue'

import {API_URL} from '@/config'

Vue.use(Router)
Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(PortalVue)
Vue.use(VueLazyLoad)
Vue.use(VueTouch, { name: 'v-touch' })

const router = new Router({
  mode: 'history',
  routes: [
    // { path: '/', name: 'Dashboard', component: Dashboard },
    { path: '/', name: 'Clients', component: Clients, meta: { protected: true } },
    { path: '/client/add', name: 'ClientsAdd', component: ClientsAdd, meta: { requiresAdmin: true, protected: true } },
    { path: '/client/:id', name: 'ClientOverview', component: ClientOverview, meta: { protected: true } },
    { path: '/client/:id/edit', name: 'ClientsEdit', component: ClientsEdit, meta: { requiresAdmin: true, protected: true } },
    { path: '/client/:id/dashboard', name: 'ClientDashboard', component: ClientDashboard, meta: { requiresAdmin: true, protected: true } },
    { path: '/client/:id/invoices', name: 'ClientsInvoices', component: ClientsInvoices, meta: { protected: true } },
    { path: '/client/:id/campaigns', name: 'ClientsCampaigns', component: ClientsCampaigns, meta: { protected: true } },
    { path: '/campaigns', name: 'Campaigns', component: Campaigns, meta: { protected: true } },
    { path: '/campaigns/:id', name: 'CampaignCreatives', component: CampaignCreatives, meta: { protected: true } },
    { path: '/creatives/:id/bulk', name: 'CreativeUnits', component: CreativeUnits, meta: { protected: true } },
    { path: '/creatives/:id/single/:sid', name: 'SingleCreativeUnits', component: SingleCreativeUnits, meta: { protected: true } },
    { path: '/projects', name: 'Projects', component: Projects, meta: { protected: true } },
    { path: '/templates', name: 'Templates', component: Templates, meta: { protected: true } },
    { path: '/preview.gif', name: 'GIFPreview', component: GIFPreview, meta: { protected: true } },
    { path: '/preview.jpg', name: 'JPGPreview', component: JPGPreview, meta: { protected: true } },
    { path: '/preview.png', name: 'PNGPreview', component: PNGPreview, meta: { protected: true } },
    { path: '/preview.html', name: 'HTMLPreview', component: HTMLPreview, meta: { protected: true } },
    { path: '/no-preview', name: 'NOPreview', component: NOPreview, meta: { protected: true } },
    { path: '/profile', name: 'Profile', component: Profile, meta: { protected: true } },
    { path: '/users', name: 'Users', component: Users, meta: { requiresAdmin: true, protected: true } },
    { path: '/user/add', name: 'UsersAdd', component: UsersAdd, meta: { requiresAdmin: true, protected: true } },
    { path: '/user/:id/edit', name: 'UsersEdit', component: UsersEdit, meta: { requiresAdmin: true, protected: true } },
    { path: '/encoding-profiles', name: 'EncodingProfiles', component: EncodingProfiles, meta: { protected: true } },
    { path: '/monitor', name: 'Monitor', component: Monitor, meta: { requiresAdmin: true, protected: true } },
    { path: '/assets', name: 'Assets', component: Assets, meta: { protected: true } },
    { path: '/links', name: 'Links', component: Links, meta: { protected: true } },
    { path: '/links/:type/list', name: 'ReviewLinksType', component: ReviewLinksType, meta: { protected: true } },
    { path: '/tags', name: 'Tags', component: Tags, meta: { requiresAdmin: true, protected: true } },
    { path: '/tags/detail/:id', name: 'TagDetail', component: TagsDetail, meta: { requiresAdmin: true, protected: true } },
    { path: '/tags/creative/:id', name: 'TagCreative', component: TagsCreative, meta: { requiresAdmin: true, protected: true } },
    { path: '/download/file/:id', name: 'DownloadFile', component: DownloadFile, meta: { protected: true } },
    { path: '/preview-staging', name: 'PreviewStaging', component: PreviewStaging, meta: { protected: true } },
    { path: '/admin', name: 'Admin', component: Admin, meta: { requiresAdmin: true, protected: true } },
    { path: '/render-manager', name: 'RenderManager', component: RenderManager, meta: { requiresAdmin: true, protected: true } },
    { path: '/help', name: 'Help', component: Help, meta: { protected: true } },
    { path: '/login', name: 'Login', component: Login },
    { path: '/invoices', name: 'Invoices', component: Invoices, meta: { requiresAdmin: true, protected: true } },
    { path: '/invoice/full/:id', name: 'InvoiceBreakdown', component: InvoiceBreakdown, meta: { protected: true } },
    { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword },
    { path: '/reset-password', name: 'PasswordReset', component: ForgotPassword },
    { path: '/preview/:hashid',
      component: Vue.extend({
        created () {
          window.top.location.href = `${API_URL}preview/${this.$route.params.hashid}`
        }
      }),
      meta: { protected: true }
    },
    { path: '*', name: 'PageNotFound', component: PageNotFound }
  ]
})

router.beforeEach(guards)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js